import { render, staticRenderFns } from "./TurnosPorServicio.vue?vue&type=template&id=6d8f220a&scoped=true"
import script from "./TurnosPorServicio.vue?vue&type=script&lang=js"
export * from "./TurnosPorServicio.vue?vue&type=script&lang=js"
import style0 from "./TurnosPorServicio.vue?vue&type=style&index=0&id=6d8f220a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8f220a",
  null
  
)

export default component.exports